<template>
	<div>
		<div v-if="!isRemoved">{{ getStatus }}</div>
		<el-switch
			v-else
			v-model="scope.row[tableData.bind]"
			:active-value="tableData.activeValue"
			:inactive-value="tableData.inactiveValue"
			:disabled="disabled()"
			@change="toggle"
		>
		</el-switch>
	</div>
</template>
<script>
import { accountsStatus } from '@/common/dictionary.js';
export default {
	props: ['tableData', 'scope'],
	data() {
		return {};
	},
	computed: {
		// 是否是switch之外的属性值
		isRemoved() {
			return (
				this.scope.row[this.tableData.bind] == this.tableData.activeValue ||
				this.scope.row[this.tableData.bind] == this.tableData.inactiveValue
			);
		},
		getStatus() {
			// 获取状态映射值
			return accountsStatus[this.scope.row[this.tableData.bind]];
		},
	},
	methods: {
		toggle(status) {
			if (this.tableData.toggle) {
				this.tableData.toggle(status, this.scope.row);
			}
		},
		disabled() {
			if (this.tableData.disabled) {
				if (typeof this.tableData.disabled === 'function') {
					return this.tableData.disabled(this.scope.row);
				} else return this.tableData.disabled;
			} else return false;
		},
	},
};
</script>
<style lang="scss" scoped></style>
